import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const InfrastructureForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [institutes, setInstitutes] = useState([]);
  const [schemes, setSchemes] = useState([]);
  const [states, setStates] = useState([]);
  const [regions, setRegions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [titles, setTitles] = useState([]); // For work titles based on scheme
  // Add these with your other state declarations
const [balanceInfo, setBalanceInfo] = useState(null);
const [balanceLoading, setBalanceLoading] = useState(false);
const [balanceWarning, setBalanceWarning] = useState('');
  const [fileUploading, setFileUploading] = useState(false);
const [uploadedFilePath, setUploadedFilePath] = useState('');
const [formData, setFormData] = useState({
  instituteId: '',
  schemeId: '',
  year: '25s26', // Default to 2nd quarter format
  timePeriod: '2nd-quarter', // Default to 2nd quarter
  month: '',
  asDate: '', // Added A.S date field
  asNumber: '', // Added A.S number field
  titleId: '', 
  type: '', // Added type field (New Proposal or Carry Forward)
  numberOfUnits: '',
  amount: '', // Changed from about to amount
  title: '' // This will store the selected title name
});
  // Infrastructure types options
  const infrastructureTypes = [
    "New Proposal",
    "Carry Forward"
  ];

  const years = [
  { display: '26-27', withS: '26s27', withoutS: '26-27' }
];
  const currentDate = new Date();
  const currentMonthIndex = currentDate.getMonth();
// Define months for each quarter
const quarterMonths = {
  '1st-quarter': [
    { value: '04', name: 'April' },
    { value: '05', name: 'May' },
    { value: '06', name: 'June' }
  ],
  '2nd-quarter': [
    { value: '07', name: 'July' },
    { value: '08', name: 'August' },
    { value: '09', name: 'September' }
  ],
  '3rd-quarter': [
    { value: '10', name: 'October' },
    { value: '11', name: 'November' },
    { value: '12', name: 'December' }
  ],
  '4th-quarter': [
    { value: '01', name: 'January' },
    { value: '02', name: 'February' },
    { value: '03', name: 'March' }
  ]
};


  // Get user role from localStorage
  const getUserRole = () => {
    try {
      return localStorage.getItem('userRole') || '';
    } catch (error) {
      console.error('Error accessing localStorage:', error);
      return '';
    }
  };

// Add this function after getUserRole
// Replace your current checkBalance function with this corrected version
const checkBalance = async (enteredAmount) => {
  if (!enteredAmount || enteredAmount === '0') return;
  
  setBalanceLoading(true);
  setBalanceWarning('');
  
  try {
    // Use the existing API service
    const balanceData = await api.ledger.getBalance();
    
    if (balanceData && !balanceData.error && balanceData.data && balanceData.data.length > 0) {
      const currentBalance = parseFloat(balanceData.data[0].balance);
      const requestedAmount = parseFloat(enteredAmount);
      
      console.log('Balance Check:', {
        currentBalance,
        requestedAmount,
        balanceData: balanceData.data[0]
      });
      
      // Check if requested amount exceeds available balance
      if (requestedAmount > currentBalance) {
        setBalanceWarning(`Warning: Requested amount (₹${requestedAmount.toLocaleString()}) exceeds available balance (₹${currentBalance.toLocaleString()})`);
      } else if (currentBalance < 0) {
        // Also check if balance itself is negative
        setBalanceWarning(`Warning: Insufficient balance. Current balance is ₹${currentBalance.toLocaleString()}`);
      } else {
        setBalanceWarning(''); // Clear warning if amount is within available balance
      }
      
      setBalanceInfo(balanceData.data[0]);
    }
  } catch (error) {
    console.error('Error checking balance:', error);
    setBalanceWarning('Could not verify balance. Please check manually.');
  } finally {
    setBalanceLoading(false);
  }
};

const handleFileUpload = async (file) => {
  if (!file) return;
  
  setFileUploading(true);
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await fetch(`${api.BASE_URL}/admin/upload`, {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('authToken')
      },
      body: formData
    });
    
    if (!response.ok) {
      throw new Error('Failed to upload file');
    }
    
    const data = await response.json();
    if (data && !data.error) {
      setUploadedFilePath(data.file);
      alert('File uploaded successfully!');
    } else {
      throw new Error(data.message || 'Upload failed');
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    alert(`Failed to upload file: ${error.message}`);
  } finally {
    setFileUploading(false);
  }
};
  const setInstituteBasedOnRole = (instituteList) => {
    const userRole = getUserRole();
    
    if (!instituteList || instituteList.length === 0) return;
    
    let selectedInstitute = null;
    
    if (userRole === 'state') {
      selectedInstitute = instituteList.find(inst => inst.code === 'SIR');
    } else if (userRole === 'region') {
      selectedInstitute = instituteList.find(inst => inst.code === 'RIR');
    } else if (userRole === 'district') {
      selectedInstitute = instituteList.find(inst => inst.code === 'DRC');
    }
    
    if (selectedInstitute) {
      setFormData(prevData => ({
        ...prevData,
        instituteId: selectedInstitute.id.toString()
      }));
    }
  };

  // Fetch institutes and schemes on component mount
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Get institute and scheme data using the API service
        const institutesData = await api.master.getInstitutes();
        const schemesData = await api.master.getInfraSchemes(); // Using infrastructure schemes endpoint
        
        if (institutesData && !institutesData.error) {
          setInstitutes(institutesData.data);
          setInstituteBasedOnRole(institutesData.data);
        }
        
        if (schemesData && !schemesData.error) {
          setSchemes(schemesData.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        alert('Failed to load data. Please check your connection and try again.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);

useEffect(() => {
  setFormData(prevData => ({
    ...prevData,
    month: '',
    year: '26-27'
  }));
}, [formData.timePeriod]);

  // Fetch location data based on selected institute
  useEffect(() => {
    const fetchLocationData = async () => {
      if (!formData.instituteId) return;
      
      setLoading(true);
      try {
        const selectedInstitute = institutes.find(institute => institute.id === parseInt(formData.instituteId));
        if (!selectedInstitute) return;
        
        const instituteName = selectedInstitute.name.toLowerCase();
        
        if (instituteName.includes('sird')) {
          // Fetch states for SIRD
          const statesData = await api.master.getStates();
          if (statesData && !statesData.error) {
            setStates(statesData.data);
          }
        } else if (instituteName.includes('rird')) {
          // Fetch regions for RIRD
          const regionsData = await api.master.getRegions();
          if (regionsData && !regionsData.error) {
            setRegions(regionsData.data);
          }
        } else if (instituteName.includes('drcp')) {
          // Fetch districts for DRCP
          const districtsData = await api.master.getDistricts();
          if (districtsData && !districtsData.error) {
            setDistricts(districtsData.data);
          }
        }
      } catch (error) {
        console.error('Error fetching location data:', error);
        alert('Failed to load location data. Please check your connection and try again.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchLocationData();
  }, [formData.instituteId, institutes]);

  // Fetch work titles when scheme changes
  useEffect(() => {
    const fetchTitles = async () => {
      if (!formData.schemeId) return;
      
      setLoading(true);
      try {
        // Use the proper API method from the service
        const titlesData = await api.master.getInfraTitles(formData.schemeId);
        
        if (titlesData && !titlesData.error) {
          setTitles(titlesData.data || []);
        }
      } catch (error) {
        console.error('Error fetching work titles:', error);
        alert('Failed to load work titles. Please check your connection and try again.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchTitles();
  }, [formData.schemeId]);

  // Handle input changes
// Handle input changes
const handleChange = (e) => {
  try {
    const { name, value } = e.target;
    
    // Special handling for titleId - auto-fill title based on selection
    if (name === 'titleId' && value) {
      const selectedTitle = titles.find(t => t.id === parseInt(value));
      if (selectedTitle) {
        setFormData({
          ...formData,
          [name]: value,
          title: selectedTitle.name
        });
        return;
      }
    }
    
    // Handle numeric fields (numberOfUnits and amount)
    if (name === 'numberOfUnits' || name === 'amount') {
      const numericValue = value.replace(/\D/g, '');
      setFormData({ ...formData, [name]: numericValue });
      
      // Check balance when amount is entered
      if (name === 'amount' && numericValue && numericValue !== '0') {
        checkBalance(numericValue);
      }
      
      return;
    }
    
    setFormData({ ...formData, [name]: value });
  } catch (error) {
    console.error('Error in handleChange:', error);
  }
};

  // Handle form submission
// Handle form submission
// Handle form submission
// Handle form submission
const handleSubmit = async (e) => {
  e.preventDefault();
  
  // Check if there's a balance warning and block proceeding
  if (balanceWarning) {
    alert('Cannot proceed: ' + balanceWarning);
    return;
  }
  
const requiredFields = [
  'instituteId', 'schemeId', 'year', 'timePeriod', 'month', 'asDate', 'asNumber', 'titleId', 'type', 'numberOfUnits', 'amount'
];
  const missingFields = requiredFields.filter(field => !formData[field]);
  
  if (missingFields.length > 0) {
    alert('Please fill all required fields before submitting.');
    return;
  }
  
  // ... rest of your existing handleSubmit code remains the same
  setLoading(true);
  try {
    // Get selected institute, scheme and title
    const selectedInstitute = institutes.find(institute => institute.id === parseInt(formData.instituteId));
    const selectedScheme = schemes.find(scheme => scheme.id === parseInt(formData.schemeId));
    const selectedTitle = titles.find(title => title.id === parseInt(formData.titleId));
    
    // Get center_name from localStorage
    const center_name = localStorage.getItem('name') || '';

    // Format data for API in the same structure as TrainingTable component
// Format data for API in the same structure as TrainingTable component
const finalData = {
  institute: selectedInstitute ? selectedInstitute.code : '',
  scheme: selectedScheme ? selectedScheme.code : '',
  scheme_name: selectedScheme ? selectedScheme.name : '',
  center_name: center_name,
  stitle: selectedTitle ? selectedTitle.code : '',
  title: selectedTitle ? selectedTitle.name : '',
  year: formData.year,
  month: formData.month,
  asDate: formData.asDate,
  asNumber: formData.asNumber,
  asFile: uploadedFilePath, // Add this line
  type: "Infrastructure",
  training_type: formData.type,
  units: formData.numberOfUnits,
  amount: formData.amount
};
    // Using the API endpoint
    const response = await fetch(`${api.BASE_URL}/project/infra`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('authToken')
      },
      body: JSON.stringify(finalData)
    });
    
    if (!response.ok) {
      throw new Error('Failed to submit infrastructure data');
    }
    
    const data = await response.json();
    if (data && !data.error) {
      alert('Infrastructure data submitted successfully!');
      navigate('/dashboard');
    } else {
      throw new Error(data.message || 'Error submitting data');
    }
  } catch (error) {
    console.error('Error submitting infrastructure data:', error);
    alert(`Failed to submit: ${error.message}`);
  } finally {
    setLoading(false);
  }
};

  // Get the name of the selected institute
  const getSelectedInstituteName = () => {
    if (formData.instituteId && institutes.length > 0) {
      const selectedInstitute = institutes.find(inst => inst.id === parseInt(formData.instituteId));
      return selectedInstitute ? selectedInstitute.name : '';
    }
    return '';
  };

  return (
    <div className="bg-gradient-to-b from-blue-50 to-white min-h-screen py-8 px-4">
      <div className="bg-white shadow-lg rounded-xl p-8 max-w-4xl mx-auto border border-gray-100">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 border-b pb-6">
          <div>
            <h2 className="text-2xl font-bold text-blue-800 mb-2">New Infrastructure</h2>
          </div>
        </div>
        
        {loading && (
          <div className="text-center mb-6 p-4 bg-blue-50 rounded-lg">
            <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-3 text-blue-700 font-medium">Loading data, please wait...</p>
          </div>
        )}
        
        <form className="space-y-8" onSubmit={handleSubmit}>
          {/* Basic Information */}
          <div>
            <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">Basic Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Display selected institute as text */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Institute
                </label>
                <div className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 bg-gray-50">
                  {getSelectedInstituteName()}
                </div>
              </div>
              
              {/* Scheme Selection */}
              <div className="relative">
                <label htmlFor="schemeId" className="block text-sm font-medium text-gray-700 mb-1">
                  Scheme <span className="text-red-500">*</span>
                </label>
                <select
                  id="schemeId"
                  name="schemeId"
                  required
                  value={formData.schemeId}
                  onChange={handleChange}
                  className="block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none"
                >
                  <option value="">Select Scheme</option>
                  {schemes.map(scheme => (
                    <option key={scheme.id} value={scheme.id}>
                      {scheme.name}
                    </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
                  <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          
{/* Time Period */}
<div>
  <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">Time Period</h3>
  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
    
    {/* Time Period Selection - FIRST */}
    <div className="relative">
      <label htmlFor="timePeriod" className="block text-sm font-medium text-gray-700 mb-1">
        Time Period <span className="text-red-500">*</span>
      </label>
      <select
        id="timePeriod"
        name="timePeriod"
        required
        value={formData.timePeriod}
        onChange={handleChange}
        className="block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none"
      >
        <option value="1st-quarter">1st Quarter</option>
        <option value="2nd-quarter">2nd Quarter</option>
        <option value="3rd-quarter">3rd Quarter</option>
        <option value="4th-quarter">4th Quarter</option>
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </div>
    </div>

    {/* Year Display - SECOND (display only, not selectable) */}
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Year <span className="text-red-500">*</span>
      </label>
      <div className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 bg-gray-50">
        {formData.year}
      </div>
    </div>

    {/* Month Selection - THIRD */}
    <div className="relative">
      <label htmlFor="month" className="block text-sm font-medium text-gray-700 mb-1">
        Month <span className="text-red-500">*</span>
      </label>
      <select
        id="month"
        name="month"
        required
        value={formData.month}
        onChange={handleChange}
        className="block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none"
      >
        <option value="">Select Month</option>
        {quarterMonths[formData.timePeriod]?.map((month) => (
          <option key={month.value} value={month.value}>
            {month.name}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </div>
    </div>
    
  </div>
</div>
          
 {/* Work Details */}
<div>
  <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">Work Details</h3>
  <div className="grid grid-cols-1 gap-6">
    
    {/* A.S Date and A.S Number in a row */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* A.S Date */}
      <div>
        <label htmlFor="asDate" className="block text-sm font-medium text-gray-700 mb-1">
          A.S Date <span className="text-red-500">*</span>
        </label>
        <input
          type="date"
          id="asDate"
          name="asDate"
          required
          value={formData.asDate}
          onChange={handleChange}
          className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
        />
      </div>
      
{/* A.S Number */}
<div>
  <label htmlFor="asNumber" className="block text-sm font-medium text-gray-700 mb-1">
    A.S Number <span className="text-red-500">*</span>
  </label>
  <input
    type="text"
    id="asNumber"
    name="asNumber"
    required
    value={formData.asNumber}
    onChange={handleChange}
    placeholder="Enter A.S number"
    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
  />
  
  {/* File Upload for A.S Number */}
  <div className="mt-2">
    <label htmlFor="asFile" className="block text-sm font-medium text-gray-700 mb-1">
      Upload A.S File
    </label>
    <input
      type="file"
      id="asFile"
      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
      onChange={(e) => {
        const file = e.target.files[0];
        if (file) {
          handleFileUpload(file);
        }
      }}
      disabled={fileUploading}
      className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 disabled:opacity-50"
    />
    
    {fileUploading && (
      <div className="mt-2 flex items-center text-sm text-blue-600">
        <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        Uploading file...
      </div>
    )}
    
    {uploadedFilePath && (
      <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded-md">
        <div className="flex items-center text-sm text-green-700">
          <svg className="h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          File uploaded successfully: {uploadedFilePath.split('/').pop()}
        </div>
      </div>
    )}
  </div>
</div>
    </div>
    
    {/* Title of Work Selection - Based on scheme */}
    <div className="relative">
                <label htmlFor="titleId" className="block text-sm font-medium text-gray-700 mb-1">
                  Title of Work <span className="text-red-500">*</span>
                </label>
                <select
                  id="titleId"
                  name="titleId"
                  required
                  value={formData.titleId}
                  onChange={handleChange}
                  disabled={!formData.schemeId}
                  className={`block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none ${!formData.schemeId ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                >
                  <option value="">Select Title of Work</option>
                  {titles.map(title => (
                    <option key={title.id} value={title.id}>
                      {title.name}
                    </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
                  <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
              
              {/* Type Selection - New Proposal or Carry Forward - MOVED AFTER title */}
              <div className="relative">
                <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-1">
                  Type <span className="text-red-500">*</span>
                </label>
                <select
                  id="type"
                  name="type"
                  required
                  value={formData.type}
                  onChange={handleChange}
                  className="block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none"
                >
                  <option value="">Select Type</option>
                  {infrastructureTypes.map(type => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
                  <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
              
              {/* Number of Units/Works and Amount placed in a horizontal line */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Number of Units/Works */}
                <div>
                  <label htmlFor="numberOfUnits" className="block text-sm font-medium text-gray-700 mb-1">
                    Number of Units/Works <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="numberOfUnits"
                    name="numberOfUnits"
                    required
                    value={formData.numberOfUnits}
                    onChange={handleChange}
                    placeholder="Enter number of units"
                    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
                  />
                </div>
                
                {/* Amount (renamed from About/Description) */}
  {/* Amount (renamed from About/Description) */}
<div>
  <label htmlFor="amount" className="block text-sm font-medium text-gray-700 mb-1">
    Amount <span className="text-red-500">*</span>
  </label>
  <input
    type="text"
    id="amount"
    name="amount"
    required
    value={formData.amount}
    onChange={handleChange}
    placeholder="Enter amount"
    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
  />
  
  {/* Add Balance Loading and Warning Display */}
  {balanceLoading && (
    <div className="mt-2 flex items-center text-sm text-blue-600">
      <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Checking balance...
    </div>
  )}

  {balanceWarning && (
    <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded-md">
      <div className="flex">
        <svg className="h-5 w-5 text-red-400 mr-2 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
        <div className="text-sm text-red-700">
          {balanceWarning}
        </div>
      </div>
    </div>
  )}
</div>
              
              </div>
            </div>
          </div>
          
          {/* Form action buttons */}
          <div className="pt-6 border-t border-gray-200">
            <div className="flex flex-col-reverse sm:flex-row justify-end space-y-4 space-y-reverse sm:space-y-0 sm:space-x-4">
              <button
                type="button"
                onClick={() => navigate('/dashboard')}
                className="px-5 py-2.5 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
              >
                Cancel
              </button>
           <button
  type="submit"
  disabled={loading || balanceWarning} // Disable if loading OR balance warning
  className={`px-5 py-2.5 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
    balanceWarning 
      ? 'bg-gray-400 cursor-not-allowed' 
      : 'bg-blue-600 hover:bg-blue-700'
  } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors disabled:bg-blue-300 disabled:cursor-not-allowed flex items-center justify-center`}
>
  {loading ? (
    <>
      <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Submitting...
    </>
  ) : balanceWarning ? (
    'Cannot Submit - Balance Issue'
  ) : (
    'Submit'
  )}
</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InfrastructureForm;